<template>
  <v-container fluid>
    <!-- Drawer de filtros (componente separado) -->
    <RosterFilters
      v-model="filters_open"
      :filters.sync="filters"
      :providers="providers"
      :types="types"
      :current-user="currentUser"
      @apply="onApplyFilters"
      @clear="onClearFilters"
    />

    <v-toolbar flat>
      <v-toolbar-title>Roster</v-toolbar-title>

      <!-- Badge con número de filtros activos -->
      <v-btn icon @click="filters_open = true">
        <v-badge overlap color="primary" v-if="activeFilterCount>0">
          <template v-slot:badge>{{ activeFilterCount }}</template>
          <v-icon>mdi-filter</v-icon>
        </v-badge>
        <v-icon v-else>mdi-filter</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <!--v-btn-toggle v-model="viewMode" dense>
        <v-btn value="table" small><v-icon left>mdi-table</v-icon>Tabla</v-btn>
        <v-btn value="grid" small><v-icon left>mdi-view-grid</v-icon>Grid</v-btn>
      </v-btn-toggle-->
    </v-toolbar>

    <!-- Tabla -->
    <v-data-table
      v-if="viewMode==='table'"
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="footerProps"
      class="elevation-0 pa-4"
      item-key="id"
      @update:options="fetchData"
      height="600"
        fixed-header
    >
      <template v-slot:item.media="{ item }">
        <div class="d-flex align-center">
          <template v-if="firstMedia(item)">
            <video v-if="isVideo(firstMedia(item))" :src="'https://peach.blitzhub.mx/files/' + firstMedia(item)" width="72" height="72" muted/>
            <v-img v-else :src="'https://peach.blitzhub.mx/files/' + firstMedia(item)" max-width="72" max-height="72" contain/>
          </template>
          <span v-else class="grey--text text--darken-1">Sin media</span>
        </div>
      </template>

      <template v-slot:item.categories="{ item }">
        <div class="d-flex flex-wrap">
          <v-chip v-for="cat in (item.categories || [])" :key="cat.id || cat" x-small class="mr-1 mb-1" color="primary" outlined>
            {{ cat.name || cat }}
          </v-chip>
        </div>
      </template>

      <template v-slot:item.published_at="{ item }">
        <div class="d-flex flex-wrap">
          {{ item.published_at ? item.published_at.slice(0,10) : '—' }}
        </div>
      </template>
      
      <template v-slot:item.url="{ item }">
        <div v-if="item.url" class="d-flex flex-wrap">
          <a :href="item.url" target="_blank"><v-icon small>mdi-open-in-new</v-icon></a>
        </div>
      </template>

      <template v-slot:item.media="{ item }">
        <v-chip-group v-if="item.media.length>0">
          <v-chip v-for="(m, index) in item.media" :key="index" :href="liga + '/files/' + m" target="_blank">
            <v-icon>mdi-image</v-icon>
          </v-chip>
        </v-chip-group>
      </template>

      <template v-slot:item.caption="{ item }">
        <v-tooltip v-if="item.caption!=null" left max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">
              mdi-note-text-outline
            </v-icon>
          </template>
          {{item.caption}}
        </v-tooltip>
      </template>

      <template v-slot:item.influencer="{ item }">
        <div class="d-flex flex-wrap">
          {{ item.provider == "Case Study"
            ? (item.influencer && (item.influencer.name + (item.influencer.last ? (' ' + item.influencer.last) : '')))
            : (item.influencer && item.influencer.social_networks
                ? item.influencer.social_networks[item.provider == "TikTok Content" ? 'tiktok' : 'instagram']
                : '—'
              )
          }}
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list style="font-size:13px;">
            <v-list-item @click="openEdit(item)">
              <v-icon small class="mr-2">mdi-pencil</v-icon> Editar
            </v-list-item>
            <v-list-item @click="doDelete(item.id)">
              <v-icon small class="mr-2">mdi-delete</v-icon> Eliminar
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:no-data>
        <div class="pa-6 text-center grey--text">No hay publicaciones.</div>
      </template>
    </v-data-table>

    <!-- Grid -->
    <div v-else>
      <v-row dense>
        <v-col v-for="item in items" :key="item.id" cols="2">
          <v-card class="elevation-1">
            <div class="media-cover">
              <template v-if="firstMedia(item)">
                <video v-if="isVideo(firstMedia(item))" :src="'https://peach.blitzhub.mx/files/' + firstMedia(item)" playsinline muted/>
                <v-img v-else :src="'https://peach.blitzhub.mx/files/' + firstMedia(item)"/>
              </template>
              <div v-else class="empty-media">Sin media</div>
            </div>

            <v-card-text class="py-3">
              <div class="d-flex align-center justify-space-between mb-2">
                <v-chip x-small v-if="item.provider" class="text-uppercase" color="indigo lighten-4">{{ item.provider }}</v-chip>
              </div>
              <div class="subtitle-2 font-weight-medium text-truncate-2">{{ item.caption || '—' }}</div>
              <div class="d-flex align-center justify-space-between mt-2">
                <span class="caption grey--text text--darken-1">{{ item.type || '—' }}</span>
                <span class="caption grey--text text--darken-1">{{ (item.published_at || '').slice(0,10) }}</span>
              </div>
              <div class="mt-2 d-flex flex-wrap">
                <v-chip v-for="cat in (item.categories || [])" :key="cat.id || cat" x-small class="mr-1 mb-1" color="primary" outlined>
                  {{ cat.name || cat }}
                </v-chip>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-btn text small color="primary" @click="openEdit(item)">
                <v-icon left small>mdi-pencil</v-icon> Editar
              </v-btn>
              <v-spacer/>
              <v-btn icon small :href="item.url" target="_blank" v-if="item.url">
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
              <v-btn icon small @click="doDelete(item.id)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Paginación bajo el grid -->
      <div class="d-flex justify-end mt-2">
        <v-pagination v-model="options.page" :length="pages" @input="fetchData"/>
      </div>
    </div>

    <!-- Dialog Form -->
    <v-dialog v-model="formDialog" max-width="820px" persistent>
      <RosterForm
        v-if="formDialog"
        :edited-item="editedItem"
        :current-user="currentUser"
        @close="formDialog=false"
        @saved="onSaved"
      />
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
      {{ snackbar.message }}
    </v-snackbar>

    <v-btn bottom color="#f48a5a" dark fab fixed right @click="openCreate">
      <v-icon color="white">mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import axios from 'axios'
import RosterForm from './form.vue'
import RosterFilters from './filters.vue'

const LS_KEY = 'roster.filters.v1'

export default {
  name: 'RosterIndex',
  components: { RosterForm, RosterFilters },
  data: () => ({
    filters_open:false,
    loading: false,
    items: [],
    total: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
      sortBy: [],
      sortDesc: [],
    },
    footerProps: { 'items-per-page-options': [15, 30, 50, 100] },
    formDialog: false,
    editedItem: null,
    viewMode: 'table', // 'table' | 'grid'
    providers: [
      {text:'TikTok', value:'TikTok Content'},
      {text:'Instagram Story', value:'Instagram Story'},
      {text:'Instagram Post', value:'Instagram Post'},
      {text:'Case Study', value:'Case Study'},
    ],
    types: ['video', 'image', 'carrousel'],
    // Filtros (incluye category_ids como array)
    filters: {
      id:'',
      influencer_id: '',
      provider: null,
      type: null,
      category_ids: [],
      published_at: '',
    },
    menuDate: false,
    snackbar: { show: false, color: 'success', message: '' },
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Influencer', value: 'influencer' },
      { text: 'Proveedor', value: 'provider' },
      { text: 'Tipo', value: 'type' },
      { text: 'URL', value: 'url' },
      { text: 'Caption', value: 'caption' },
      { text: 'Fecha', value: 'published_at' },
      { text: 'Categorías', value: 'categories', sortable: false },
      { text: 'Media', value: 'media', sortable: false },
      { value: 'actions', sortable: false, align: 'end' },
    ],
  }),
  computed: {
    liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
    currentUser(){
      return this.$store.state.currentUser.user
    },
    pages(){
      const len = Math.ceil(this.total / (this.options.itemsPerPage || 15))
      return isFinite(len) && len > 0 ? len : 1
    },
    activeFilterCount(){
      const f = this.filters
      let count = 0
      if (f.id) count++
      if (f.influencer_id) count++
      if (f.provider) count++
      if (f.type) count++
      if (Array.isArray(f.category_ids) && f.category_ids.length) count++
      if (f.published_at) count++
      return count
    }
  },
  watch: {
    // Persistencia en LocalStorage
    filters: {
      deep: true,
      handler (v) {
        try { localStorage.setItem(LS_KEY, JSON.stringify(v)) } catch(e){}
      }
    },
    // Recarga cuando cambian opciones de tabla
    options: { deep: true, handler(){ /* fetchData is bound on update:options */ } },
  },
  mounted(){
    // Restaurar filtros
    try {
      const saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null')
      if (saved && typeof saved === 'object') {
        // validación simple
        this.filters = {
          id: saved.id || '',
          influencer_id: saved.influencer_id || '',
          provider: saved.provider || null,
          type: saved.type || null,
          category_ids: Array.isArray(saved.category_ids) ? saved.category_ids.map(n => +n).filter(Number.isFinite) : [],
          published_at: saved.published_at || '',
        }
      }
    } catch(e){}
    this.fetchData()
  },
  methods: {
    // Helpers media
    firstMedia(item){
      const m = Array.isArray(item.media) ? item.media : []
      return m.length ? m[0] : null
    },
    isVideo(url){
      return /\.mp4($|\?)/i.test(url || '')
    },

    // UI
    openCreate(){
      this.editedItem = null
      this.formDialog = true
    },
    openEdit(item){
      this.editedItem = { ...item }
      this.formDialog = true
    },
    onSaved(){
      this.formDialog = false
      this.fetchData()
      this.toast('Guardado correctamente')
    },
    onApplyFilters(){
      this.options.page = 1
      this.fetchData()
    },
    onClearFilters(){
      this.options.page = 1
      this.fetchData()
    },
    toast(message, color='success'){
      this.snackbar = { show: true, color, message }
    },

    // API
    async fetchData(){
      this.loading = true
      try{
        const { page, itemsPerPage, sortBy, sortDesc } = this.options
        // construir sort=field,-other
        let sort = ''
        if (Array.isArray(sortBy) && sortBy.length){
          const parts = sortBy.map((f, i) => sortDesc[i] ? `-${f}` : f)
          sort = `&sort=${parts.join(',')}`
        }

        // filtros: construimos query
        const params = []
        const f = this.filters

        console.log(f)

        if (f.id) params.push(`filter[id]=${encodeURIComponent(f.id)}`)
        if (f.influencer_id) params.push(`filter[influencer_id]=${encodeURIComponent(f.influencer_id)}`)
        if (f.provider) params.push(`filter[provider]=${encodeURIComponent(f.provider)}`)
        if (f.type) params.push(`filter[type]=${encodeURIComponent(f.type)}`)
        if (Array.isArray(f.category_ids) && f.category_ids.length){
          // Soporta múltiples categorías: usa filter[categories]=1,2
          params.push(`filter[categories]=${encodeURIComponent(f.category_ids.join(','))}`)
        }
        if (f.published_at) params.push(`filter[published_at]=${encodeURIComponent(f.published_at)}`)

        const link =
          `${process.env.VUE_APP_BACKEND_ROUTE}api/v1/roster?` +
          `page=${page}&itemsPerPage=${itemsPerPage}${sort}` +
          (params.length ? `&${params.join('&')}` : '')

        const { data } = await axios.get(link)
        // Backend esperado: { data: [], meta: { total: N } }
        this.items = data.data || data
        this.total = data.meta?.total ?? (Array.isArray(data.data) ? data.data.length : 0)
      }catch(e){
        this.toast('No se pudieron cargar los datos', 'error')
      }finally{
        this.loading = false
      }
    },

    async doDelete(id){
      const yes = confirm(`¿Eliminar publicación #${id}?`)
      if(!yes) return
      try{
        await axios.delete(`${process.env.VUE_APP_BACKEND_ROUTE}api/v1/roster/${id}`)
        this.toast('Registro eliminado')
        this.fetchData()
      }catch(e){
        this.toast('No se pudo eliminar', 'error')
      }
    },
  }
}
</script>

<style scoped>
.media-cover {
  position: center;
  width: 100%;
  height: 250px;
  overflow: hidden;
  background: #f6f6f6;
  display: grid;
  place-items: center;
}
.media-cover video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.empty-media {
  color:#999;
  font-size: 12px;
}
.text-truncate-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>


<style>
    .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
        box-shadow: none!important;
        background: #f7f7f7;
    }
    
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
        padding: 0 8px!important;
    }
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
        font-size:13px!important;
    }
    .v-row-group__header .ma-0.v-btn.v-btn--icon.v-btn--round.theme--light.v-size--small:nth-child(2){
        display:none!important;
    }
    .v-data-table-header th {
        white-space: nowrap;
    }
    .theme--light.v-data-table .v-row-group__header, .theme--light.v-data-table .v-row-group__summary {
        background: #f4f5fa;
    }
    .v-text-field--outlined fieldset {
        border-color: #e0e0e0;
    }
    .v-list-item__action {
        margin: 0px 20px 0px 0px!important;
    }
    .v-menu__content.theme--light.menuable__content__active{
        max-height: 85vh!important;
    }

    .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
        padding: 0 0px!important;
    }
    .btnText2{
        padding: 0px!important;
        height: auto!important;
        background: rgb(219, 219, 219)!important;
        box-shadow: none!important;
        /*text-transform: none;*/
        font-weight: 400;
        font-family: "Roboto", sans-serif;
        letter-spacing: 0;
        color: #1f1f1f!important;
        text-decoration: none!important;
    }


    .is_active{
        border-left: 3px solid #4385f3;
    }
    .is_inactive{
        border-left: 3px solid #33a952;
    }

    .is_activeStyle-1 {
        background-color: #fff2ca;
        border-left: 3px solid #4385f3;
    }
    .is_activeStyle-2 {
        background-color: #d9ebff;
        border-left: 3px solid #4385f3;
    }
    .is_activeStyle-3 {
        background-color: #0080002b;
        border-left: 3px solid #4385f3;
    }
    .is_activeStyle-4 {
        background-color: #ff75002b;
        border-left: 3px solid #4385f3;
    }

    .is_inactiveStyle-1 {
        background-color: #fff2ca;
        border-left: 3px solid #33a952;
    }
    .is_inactiveStyle-2 {
        background-color: #d9ebff;
        border-left: 3px solid #33a952;
    }
    .is_inactiveStyle-3 {
        background-color: #0080002b;
        border-left: 3px solid #33a952;
    }
    .is_inactiveStyle-4 {
        background-color: #ff75002b;
        border-left: 3px solid #33a952;
    }


    table{
        border-collapse: collapse;
    }

    .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
        padding: 0 5px !important;
        font-size:10px!important;
    }

    th.text-start.sortable.active.asc{
        z-index:4;
    }

</style>